import { SkeletonTheme } from '@/components/Skeleton/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Skeleton = GenericSlot({ as: 'div', theme: SkeletonTheme });
